<template>
    <div
        v-click-outside="close"
        class="map-items-options-menu"
    >
        <img
            src="/images/map/more-options.svg"
            class="map-items-options-icon"
            alt="More options"
            @click="toggleOpen()"
        />
        <ul
            v-if="isOpen"
            class="map-items-options-content"
        >
            <li
                class="map-items-options__item"
                @click="$emit('clear')"
            >
                Clear
            </li>
        </ul>
    </div>
</template>

<script>
import canClose from '@/mixins/canClose'

export default {
    mixins: [canClose],

    data() {
        return {
            isOpen: false,
        }
    },

    methods: {
        close(event) {
            const hasAnotherAlertOpen = this.hasBlockingClass(event)

            if (!hasAnotherAlertOpen) {
                this.isOpen = false
            }
        },

        toggleOpen() {
            this.isOpen = !this.isOpen
        },
    },
}
</script>

<style scoped>
.map-items-options-menu {
    position: relative;
}

.map-items-options-icon {
    position: relative;
    z-index: 100;
}

.map-items-options-content {
    position: absolute;
    right: 0;
    top: -15px;
    background-color: #333a3d;
    width: 114px;
    padding: 8px 0 8px 0;
}

.map-items-options__item {
    line-height: 28px;
    padding-left: 10px;
    font-size: 12px;
    cursor: pointer;
}
</style>
